module.exports = __webpack_public_path__ + "static/media/jamie_pcr_product_j.353b7e04.svg";